
import { GlobalController } from 'src/shared/global/GlobalController'
import Index from './Index'
import ServiceRequestStart from './view/ServiceRequestStart'
import ServiceRequestCreate from './view/ServiceRequestCreate'
import ServiceRequestBase from './view/ServiceRequestBase'
import ServiceRequestList from './view/ServiceRequestList'
import ServiceRequestConsumerUnit from './view/ServiceRequestConsumerUnit'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'service-request',
    name: 'serviceRequest',
    component: Index,
    beforeEnter: ifAuthenticated,
    props: true,
    redirect: {
      name:
        'serviceRequest.start'
    },
    children: [
      {
        path: 'start',
        name:
          'serviceRequest.start',
        component: ServiceRequestStart,
        beforeEnter: ifAuthenticated,
        props: true
      },
      {
        path: 'list/:protocol',
        name:
          'serviceRequest.list',
        component: ServiceRequestList,
        beforeEnter: ifAuthenticated,
        props: true,
        meta: {
          fillContainer: true
        }
      },
      {
        path: 'create/:client/:origin/:type',
        name:
          'serviceRequest.create',
        component: ServiceRequestCreate,
        beforeEnter: ifAuthenticated,
        props: true,
        meta: {
          fillContainer: true
        }
      },
      {
        path: 'consumer-unit/:protocol/:consumerUnit',
        name:
          'serviceRequest.consumer-unit',
        component: ServiceRequestConsumerUnit,
        beforeEnter: ifAuthenticated,
        props: true,
        meta: {
          fillContainer: true
        },
        children: [
          {
            path: 'remover',
            name:
              'serviceRequest.base',
            component: ServiceRequestBase,
            beforeEnter: ifAuthenticated,
            props: true,
            meta: {
              fillContainer: true
            }
          },
          ...require('./view/service-order/routes').routes,
          ...require('./view/request/routes').routes,
          ...require('./view/financial/routes').routes,
          ...require('./view/registration-information/routes').routes
        ]
      }
    ]
  }
]
